import { render, staticRenderFns } from "./SimpleSignSignapiExterno.vue?vue&type=template&id=4697cf14&"
import script from "./SimpleSignSignapiExterno.vue?vue&type=script&lang=js&"
export * from "./SimpleSignSignapiExterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4697cf14')) {
      api.createRecord('4697cf14', component.options)
    } else {
      api.reload('4697cf14', component.options)
    }
    module.hot.accept("./SimpleSignSignapiExterno.vue?vue&type=template&id=4697cf14&", function () {
      api.rerender('4697cf14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/signapiExterno/SimpleSignSignapiExterno.vue"
export default component.exports